import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "paymentCollection/fetch";
    ActionTypes["fetchSuccess"] = "paymentCollection/fetchSuccess";
    ActionTypes["fetchError"] = "paymentCollection/fetchError";
    ActionTypes["reset"] = "paymentCollection/reset";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => ({
        payload: {}
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (paymentCollection) => ({
        payload: { paymentCollection }
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: { error }
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    }))
};
